import Repository from './Repository';

const resource = "/logs";
export default {
    page(user_id, page=1, limit=10) {
        var offset = (page - 1) * limit
        return Repository.get(`${resource}/?user=${user_id}&limit=${limit}&offset=${offset}`);
    },
}